/**
 * Where a held finger is while the user talks on a phone, as the overlay
 * draws it: on the arc at the bottom (letting go sends), or above it on 取消
 * (left) or 编辑 (right). Read from where the finger is, not how far it
 * moved: a hold from the box's mic starts high, above the keyboard, which
 * closes under it as the overlay comes up.
 */
export type HoldZone = 'send' | 'cancel' | 'edit';

/** The overlay's arc, from the bottom edge, where letting go sends. */
export const kHoldArcHeight = 150;

/** The zone of a finger now at window `x`, `y`. */
export function holdZoneAt({
  x,
  y,
  moved,
  width,
  height,
  arcHeight,
  minMove,
}: {
  x: number;
  y: number;
  /** How far the finger has moved since it pressed. */
  moved: number;
  width: number;
  height: number;
  arcHeight: number;
  /** Until it has moved this far a hold sends, wherever it began. */
  minMove: number;
}): HoldZone {
  if (moved < minMove || y >= height - arcHeight) return 'send';
  return x < width / 2 ? 'cancel' : 'edit';
}
